import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup, Form } from '@angular/forms';
import { AzureAuthService } from 'src/service/azure-auth.service';

import { UserService } from 'src/api/services/user.service';
import { ApplicationConfigService } from 'src/service/application-config.service';

@Component({
  selector: 'app-on-boarding',
  templateUrl: './on-boarding.component.html',
  styleUrls: ['./on-boarding.component.scss']
})
export class OnBoardingComponent implements OnInit {
  public readonly onboardingGroupModel: FormGroup = this.formBuilder.group({
    fullName: ['', [Validators.required,Validators.minLength(4)]],
    emailAddress: ['', [Validators.required, Validators.email, Validators.minLength(8)]],
    mobileNumber: ['', [Validators.required, Validators.minLength(9)]]
  });

  public step = 0;
  public acceptedTerms = false;

  constructor(
    private azureAuthService: AzureAuthService,
    public config: ApplicationConfigService,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private router: Router) { }

  async ngOnInit() : Promise<void> {
    this.config.init().then(r => {
      console.log("Settings:", this.config.settings);

      //const user = this.azureAuthService.userProfile;
      this.azureAuthService.userProfileCreateReturn().then(user => {  
        this.onboardingGroupModel.setValue({
          fullName: user.fullName,
          emailAddress: user.emailAddress,
          mobileNumber: user.mobileNumber
        });
      });
    });
  }

  submitOnboarding(): void {
    const currentUser = this.azureAuthService.userProfile;

    currentUser.fullName = this.onboardingGroupModel.value['fullName'];
    currentUser.emailAddress = this.onboardingGroupModel.value['emailAddress'];
    currentUser.mobileNumber = this.onboardingGroupModel.value['mobileNumber'];
    currentUser.acceptedTerms = this.acceptedTerms;

    // todo - error handling
    this.userService.UserOnboardUser(currentUser)
      .subscribe(
        res => {
          currentUser.isOnboarded = true;
          this.router.navigate(['/home']);
        },
        err => {
          console.error("ERROR: submitOnboarding", err)
        }
      )
  }
}
